import { Grid2, styled } from "@mui/material"
import { Stack } from "src/shared/components"
import heroImage from "src/assets/images/login-hero.webp"
import { ReactElement, useContext } from "react"
import ModeSwitch from "src/shared/components/mode-switch"
import { ThemeContext } from "src/shared/context/theme-context"

const AuthLayout = ({ children }: { children: ReactElement }) => {
  const themeContext = useContext(ThemeContext)
  return (
    <Stack sx={{ width: "100%", height: "1px", minHeight: "100vh" }}>
      <ModeSwitch
        sx={{ position: "absolute", bottom: 10, right: 10 }}
        checked={themeContext?.mode === "dark"}
        onChange={() => themeContext?.toggleTheme()}
      />

      <Grid2 container sx={{ height: "100%" }}>
        <Grid2 size={{ md: 8 }} display={{ xs: "none", md: "block" }}>
          <HeroImge src={heroImage} alt="img" />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }} sx={{ px: { xs: 2, md: 5 } }}>
          {children}
        </Grid2>
      </Grid2>
    </Stack>
  )
}

export default AuthLayout

const HeroImge = styled("img")({
  width: "100%",
  height: "100%",
  maxHeight: "100vh",
  objectFit: "cover",
  objectPosition: "bottom left"
})
